import React, { memo } from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

/**
 * Global search bar for ERP list pages.
 * Parent should use useDebouncedValue(search, 400) and pass debounced value to the fetch.
 */
const GlobalSearchBar = memo(function GlobalSearchBar({
  value,
  onChange,
  placeholder = "Search by name, ID, email, phone…",
  size = "small",
  fullWidth = true,
  sx = {},
  ...rest
}) {
  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
      }}
      sx={{ maxWidth: 400, ...sx }}
      {...rest}
    />
  );
});
export default GlobalSearchBar;
